import { Injectable } from '@angular/core';

import { TellentHttpApiService } from '@tellent/http';
import { TellentAppsResponse } from '@tellent/types';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TellentAppsHttpClient {
  constructor(protected httpApi: TellentHttpApiService) {}

  public fetchApps(): Observable<TellentAppsResponse> {
    return this.httpApi.get('/apps');
  }
}
